import { Badge, Stack } from 'react-bootstrap';

import styles from './FilterBadge.module.scss';

interface IFilterBadgeProps {
    disabled?: boolean;
    isLoading?: boolean;
    label?: string;
    onRemove: () => void;
}
export function FilterBadge(props: IFilterBadgeProps) {
    if (!props.label) return null;

    return (
        <Badge
            bg="#ffffff"
            onClick={() => {
                if (props.disabled) return;
                props.onRemove();
            }}
            className={`color-darkgray ${styles.filter}`}
            key={props.label}
            style={{
                cursor: props.disabled ? 'default' : 'pointer',
            }}
            title={props.disabled ? '' : 'Remove Filter'}
        >
            <Stack direction="horizontal" gap={1}>
                <span style={{ fontWeight: 400 }}>
                    {props.isLoading ? 'Loading...' : props.label}
                </span>
                {(!props.disabled || props.isLoading) && (
                    <span>
                        <i className="fa fa-times fs-xs" />
                    </span>
                )}
            </Stack>
        </Badge>
    );
}
